/* eslint-disable react-hooks/exhaustive-deps */
import React, { useMemo } from "react";
import { useAtom, useSetAtom, useAtomValue } from "jotai";
import { includes } from "lodash";
import { bookmarkStore, unlockBookStore } from "@stores/bookdata";
import { bookInfoPopState } from "@stores/popup";
import { unlockState } from "@stores/modal";
import styled from "styled-components";
import useModal from "@hooks/useModal";

//
const Wrap = styled.div`
  position: relative;
  width: 360px;
  &.bookmark {
    animation: slideIn 0.3s;
  }
`;

const LockCover = styled.div`
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: calc(100% - 44px);
  background-color: rgba(0, 0, 0, 0.65);
  z-index: 1;
  border-radius: 25px;
  &:after {
    content: "";
    position: absolute;
    width: 141px;
    height: 169px;
    display: inline-block;
    background-size: 100% 100%;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
  }

  &.c1 {
    &:after {
      background: url(${require("@assets/img/lock_red.png")}) no-repeat;
    }
  }
  &.c2 {
    &:after {
      background: url(${require("@assets/img/lock_orange.png")}) no-repeat;
    }
  }
  &.c3 {
    &:after {
      background: url(${require("@assets/img/lock_yellow.png")}) no-repeat;
    }
  }
  &.c4 {
    &:after {
      background: url(${require("@assets/img/lock_green.png")}) no-repeat;
    }
  }
  &.c5 {
    &:after {
      background: url(${require("@assets/img/lock_blue.png")}) no-repeat;
    }
  }
  &.c6 {
    &:after {
      background: url(${require("@assets/img/lock_navi.png")}) no-repeat;
    }
  }
  &.c7 {
    &:after {
      background: url(${require("@assets/img/lock_purple.png")}) no-repeat;
    }
  }
  &.c8 {
    &:after {
      background: url(${require("@assets/img/lock_ido.png")}) no-repeat;
    }
  }
`;

const LabelBox = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 358px;
  height: 358px;
  border-radius: 25px;
  background-color: #fefefe;
  margin-right: 15px;
  background: url(${({ url }) => url});
  background-size: cover;
  background-position: 50% 50%;
`;
const Title = styled.div`
  color: #fff;
  font-size: 35px;
  margin-top: 10px;
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const BookmarkIcon = styled.button`
  position: absolute;
  top: 10px;
  right: 10px;
  width: 73px;
  height: 73px;
  display: inline-block;
  background: url(${require("@assets/img/icon_bookmark.png")}) no-repeat;
  &.on {
    background: url(${require("@assets/img/icon_bookmark_on.png")}) no-repeat;
  }
`;

const BookmarkLabel = styled.span`
  padding: 6px 16px 2px;
  background-color: #fff;
  border-radius: 25px;
  font-size: 30px;
  margin-right: 10px;
  background-color: ${({ color }) => color};
`;

const BookItemCover = ({ bookData, isBookmark = false }) => {
  const [curBookMark, setBookMark] = useAtom(bookmarkStore);
  const unlockData = useAtomValue(unlockBookStore);
  const setBookInfo = useSetAtom(bookInfoPopState);
  const setUnLock = useSetAtom(unlockState);
  const { showAlert } = useModal();

  const onClickItem = () => {
    setBookInfo({
      ...bookData,
      open: true,
    });
  };

  const onClickBookMark = () => {
    const key = bookData.key;
    const title = bookData.title;
    if (isBookmark) {
      showAlert(
        `<div style="color: #ffd35c;">${title}</div><div style="font-size: 50px; margin-top: 35px;">즐겨찾기에서 삭제하시겠습니까?</div>`,
        "confirm"
      ).then((value) => {
        if (value === true) {
          removeItem(key);
        }
      });
      return;
    }
    if (curBookMark.filter((a) => a === key).length > 0) {
      showAlert(
        `<div style="color: #ffd35c;">${title}</div><div style="font-size: 50px; margin-top: 35px;">즐겨찾기에서 삭제하시겠습니까?</div>`,
        "confirm"
      ).then((value) => {
        if (value === true) {
          removeItem(key);
        }
      });
      removeItem(key);
    } else {
      showAlert(
        `<div style="color: #ffd35c;">${title}</div><div style="font-size: 50px; margin-top: 35px;">즐겨찾기에 추가하시겠습니까?</div>`,
        "confirm"
      ).then((value) => {
        if (value === true) {
          addItem(key);
        }
      });
    }
  };

  const addItem = (key) => {
    const newValue = [...curBookMark];
    if (newValue.length >= 10) {
      showAlert("즐겨찾기는 <br>10개까지만 가능해요!", "alert");
      return;
    }
    newValue.push(key);
    setBookMark(newValue);
  };

  const removeItem = (key) => {
    const arr = curBookMark.filter((a) => a !== key);
    setBookMark(arr);
  };

  const isOn = () => {
    // 북마크일경우 무조건 아이콘 활성화
    if (isBookmark) return "on";
    const c = curBookMark.filter((key) => key === bookData.key);
    return c.length > 0 ? "on" : "";
  };

  const openUnLock = () => {
    setUnLock({
      show: true,
      data: bookData,
    });
  };

  const renderCover = useMemo(() => {
    if (includes(unlockData, bookData.key)) {
      return null;
    }
    return <LockCover onClick={openUnLock} className={bookData.categoryKey} />;
  }, [bookData, unlockData]);

  return (
    <Wrap className={isBookmark ? "bookmark" : ""}>
      {renderCover}

      <LabelBox url={bookData.cover} onClick={onClickItem} />
      <BookmarkIcon
        type="button"
        onClick={onClickBookMark}
        className={isOn()}
      />
      <Title>
        {isBookmark && (
          <BookmarkLabel color={bookData.color}>
            {bookData.category}
          </BookmarkLabel>
        )}
        {bookData.grade}
      </Title>
    </Wrap>
  );
};

export default React.memo(BookItemCover);
